import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import bezier from 'bezier-easing';
import { UpgraderService } from '../upgrader.service';
import { sleep } from '@core/utils/sleep.util';
import { animateElement } from '@core/utils/deprecated.utils';
import {
  CircleProgressOptions,
  NgCircleProgressModule,
} from 'ng-circle-progress';
import { fadeInAnimation } from '@core/utils/animations.util';

@Component({
  selector: 'app-upgrader-main',
  templateUrl: './upgrader-main.component.html',
  styleUrls: ['./upgrader-main.component.scss'],
  imports: [NgCircleProgressModule],
  providers: [
    {
      provide: CircleProgressOptions,
    },
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInAnimation],
})
export class UpgraderMainComponent {
  ball = viewChild.required<ElementRef>('ball');

  circleColor = signal<string>('var(--yellow)');

  public upgraderService = inject(UpgraderService);

  changeUnderOverState(value: boolean) {
    if (this.upgraderService.isProcessing()) {
      return;
    }

    this.upgraderService.toggleUnder(value);
  }

  async roll() {
    if (this.upgraderService.isProcessing()) {
      return;
    }

    const res = await this.upgraderService.upgrade();

    if (!res) {
      return;
    }

    try {
      const isWon = res.won;
      const rotateLength = 360 * 5 + (res.percentage / 100) * 360;
      await animateElement(
        (p: number) => {
          this.ball().nativeElement.style.transform = `translate(-50%, -50%) rotate(${
            p * rotateLength
          }deg)`;
        },
        11000,
        bezier(0, 0.75, 0, 1)
      );

      this.ball().nativeElement.style.transform = `translate(-50%, -50%) rotate(${
        (res.percentage / 100) * 360
      }deg)`;
      this.circleColor.set(isWon ? 'var(--green)' : 'var(--red)');
      await sleep(1000);
      await animateElement(
        (p: number) => {
          this.ball().nativeElement.style.transform = `translate(-50%, -50%) rotate(${
            (res.percentage / 100) * 360 * (1 - p)
          }deg)`;
        },
        300,
        bezier(0, 0, 0, 0)
      );

      this.ball().nativeElement.style.transform = `translate(-50%, -50%) rotate(0deg)`;

      if (isWon) {
        this.upgraderService.selectedSkinsS.set([]);
      }

      this.circleColor.set('var(--yellow)');
      this.upgraderService.setBetAmount(this.upgraderService.betAmount());
    } catch {
    } finally {
      this.upgraderService.isProcessing.set(false);
    }
  }
}
